export const MCP_OAUTH_CHANNEL = "clvabot-mcp-oauth";
